function runAt(selector, callback) {
  function check() {
    if (document.querySelector(selector)) {
      callback();
    } else {
      requestAnimationFrame(check);
    }
  }
  requestAnimationFrame(check);
}

function getSelectors() {
  const quizMain = document.querySelector(".ge-quiz_section");
  const questionData = document.querySelector("#quiz_question--data");
  const quizData = JSON.parse(questionData.textContent);
  const resultData = document.querySelector("#quiz_result--data");
  const resultJSON = JSON.parse(resultData.textContent);
  return {
    quizMain,
    quizData,
    resultJSON,
    welcomeContainer: quizMain.querySelector(".quiz-welcome_container"),
    quizContainer: quizMain.querySelector(".quiz-question_container"),
    quizButtons: quizMain.querySelector(".ge-quiz--footer"),
    nextBtn: quizMain.querySelector(".quiz-next_button"),
    prevBtn: quizMain.querySelector(".quiz-prev_button"),
    progressBar: quizMain.querySelector(".quiz--progress_bar"),
    progressPercent: quizMain.querySelector(".progress--percent"),
    resultContainer: quizMain.querySelector(".quiz-result_container"),
  };
}

let productScores = {};
let selectedAnswers = [];
let currentQuestionIndex = 0;
let selectedColor = "";
let visibleQuestions = [];
let groupedVariants = {};

const selectors = getSelectors();


selectors.quizData.forEach((question) => {
  if (question.type === "question") {
    question.answers.forEach((answer) => {
      if (answer.products) {
        answer.products.forEach((product) => {
          productScores[product.p_title] = 0;
        });
      }
    });
  }
});

function globalFunction() {
  const selectors = getSelectors();
  if (selectors.quizContainer) {
    loadWelcomePage(selectors);
  }
}

function updateProgress(selectors, currentIndex) {
  const totalSteps = visibleQuestions.length + 1;
  let progress;

  if (currentIndex === -1) {
    progress = 0;
  } else if (currentIndex < visibleQuestions.length) {
    progress = ((currentIndex + 1) / totalSteps) * 100;
  } else {
    progress = 100;
  }

  selectors.progressBar.style.width = `${progress}%`;
  selectors.progressPercent.textContent = `${Math.round(progress)}%`;
}

function renderFooterButtons(selectors) {
  const resultData = selectors.resultJSON;
  selectors.quizButtons.innerHTML = `
    <button class="quiz-button quiz-prev_button">
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <g clip-path="url(#clip0_8246_294)">
          <path d="M23 12H2" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
          <path d="M8.75 18.75L2 12L8.75 5.25" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
        </g>
        <defs>
          <clipPath id="clip0_8246_294">
            <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
          </clipPath>
        </defs>
      </svg>
      ${resultData.prev}
    </button>
    <button class="quiz-button quiz-next_button">
      ${resultData.next}
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <g clip-path="url(#clip0_8246_311)">
          <path d="M2 12L23 12" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
          <path d="M16.25 5.25L23 12L16.25 18.75" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
        </g>
        <defs>
          <clipPath id="clip0_8246_311">
            <rect width="24" height="24" fill="white" transform="translate(24.5 24) rotate(-180)"/>
          </clipPath>
        </defs>
      </svg>
    </button>
  `;

  selectors.prevBtn = selectors.quizButtons.querySelector(".quiz-prev_button");
  selectors.nextBtn = selectors.quizButtons.querySelector(".quiz-next_button");

  selectors.prevBtn.addEventListener("click", () => {
    if (currentQuestionIndex > 0) {
      currentQuestionIndex--;
      loadQuestion(selectors);
      updateProgress(selectors, currentQuestionIndex);
    } else if (currentQuestionIndex === 0) {
      currentQuestionIndex = -1;
      loadWelcomePage(selectors);
      updateProgress(selectors, currentQuestionIndex);
    }
  });

  selectors.nextBtn.addEventListener("click", () => {
    currentQuestionIndex++;
    if (currentQuestionIndex < visibleQuestions.length) {
      loadQuestion(selectors);
      updateProgress(selectors, currentQuestionIndex);
    } else {
      showResult(selectors);
      updateProgress(selectors, currentQuestionIndex);
    }
  });

  if (
    typeof selectedAnswers[visibleQuestions[currentQuestionIndex]] !==
    "undefined"
  ) {
    selectors.nextBtn.removeAttribute("disabled");
  } else {
    selectors.nextBtn.setAttribute("disabled", "true");
  }

  if (currentQuestionIndex > 0) {
    selectors.prevBtn.removeAttribute("disabled");
  } else {
    selectors.prevBtn.setAttribute("disabled", "true");
  }
}

function loadWelcomePage(selectors) {
  selectors.quizButtons.classList.add("hidden");
  selectors.quizContainer.classList.add("hidden");
  selectors.resultContainer.classList.add("hidden");
  updateProgress(selectors, -1);
  selectors.progressBar.style.width = "1%";

  const startButton =
    selectors.welcomeContainer.querySelector("#quiz_start-button");
  startButton.addEventListener("click", function () {
    startQuiz();
    selectors.welcomeContainer.classList.add("hidden");
    selectors.welcomeContainer.innerHTML = "";
    selectors.quizButtons.classList.remove("hidden");
    selectors.quizContainer.classList.remove("hidden");
  });
}

function startQuiz() {
  const selectors = getSelectors();
  currentQuestionIndex = 0;
  updateVisibleQuestions();
  loadQuestion(selectors);
  updateProgress(selectors, 0);
}

function updateVisibleQuestions() {
  visibleQuestions = [];
  selectors.quizData.forEach((question, index) => {
    if (question.showIf) {
      const depQuestionIndex = parseInt(question.showIf.questionIndex);
      const depAnswerIndex = parseInt(question.showIf.answerIndex);
      const depQuestion = selectors.quizData[depQuestionIndex];
      if (!depQuestion) {
        console.error(`Invalid questionIndex: ${depQuestionIndex}`);
        return;
      }
      if (selectedAnswers[depQuestionIndex] !== depAnswerIndex) return;
    }
    visibleQuestions.push(index);
  });
}

function loadQuestion(selectors) {
  const questionIndex = visibleQuestions[currentQuestionIndex];
  const questionData = selectors.quizData[questionIndex];

  if (questionData.type === "question") {
    selectors.quizContainer.className = `quiz-question_container question step-${
      currentQuestionIndex + 1
    }`;
    selectors.quizContainer.innerHTML = `
      <div class="question--media">
        <img src="${questionData.image}" alt="${
      questionData.question
    }" width="" height="" class="image">
      </div>
      <div class="question--content">
        <h2 class="question--title">${questionData.question}</h2>
        <div class="question--options">
          ${questionData.answers
            .map(
              (answer, index) => `
              <button class="option--button" data-index="${index}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="12" fill="currentColor"/>
                  <path d="M18.8134 8.17489C18.8726 8.11099 18.9195 8.03511 18.9515 7.95161C18.9835 7.86811 19 7.77862 19 7.68824C19 7.59786 18.9835 7.50836 18.9515 7.42486C18.9195 7.34136 18.8726 7.26549 18.8134 7.20158C18.7542 7.13767 18.684 7.08698 18.6067 7.05239C18.5294 7.0178 18.4466 7 18.3629 7C18.2792 7 18.1964 7.0178 18.1191 7.05239C18.0418 7.08698 17.9716 7.13767 17.9124 7.20158L9.45484 16.3395L6.08759 12.7005C6.02843 12.6366 5.9582 12.5859 5.8809 12.5513C5.8036 12.5168 5.72076 12.499 5.63709 12.499C5.55343 12.499 5.47058 12.5168 5.39329 12.5513C5.31599 12.5859 5.24576 12.6366 5.1866 12.7005C5.12744 12.7644 5.08051 12.8403 5.0485 12.9238C5.01648 13.0073 5 13.0968 5 13.1872C5 13.2776 5.01648 13.3671 5.0485 13.4506C5.08051 13.5341 5.12744 13.6099 5.1866 13.6738L9.00434 17.7981C9.06345 17.8621 9.13367 17.9129 9.21097 17.9475C9.28827 17.9822 9.37114 18 9.45484 18C9.53853 18 9.6214 17.9822 9.69871 17.9475C9.77601 17.9129 9.84623 17.8621 9.90533 17.7981L18.8134 8.17489Z" fill="white"/>
                </svg>
                ${answer.text}
              </button>`
            )
            .join("")}
        </div>
        <div class="question--text prose">${questionData.content || ""}</div>
      </div>
    `;
  } else if (questionData.type === "color-option") {
    selectors.quizContainer.className = `quiz-question_container color-option step-${
      currentQuestionIndex + 1
    }`;
    const validGroups = Object.keys(colorGroups).filter(
      (group) =>
        Array.isArray(colorGroups[group].variants) &&
        colorGroups[group].variants.length > 0
    );

    selectors.quizContainer.innerHTML = `
      <div class="question--media">
        <img src="${questionData.image}" alt="${
      questionData.question
    }" width="" height="" class="image">
      </div>
      <div class="question--content">
        <h2 class="question--title">${questionData.question}</h2>
        <div class="color--options">
          ${validGroups
            .map(
              (group, index) => `
              <button class="color--button" data-index="${index}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="12" fill="#E93F86"/>
                  <path d="M18.8134 8.17489C18.8726 8.11099 18.9195 8.03511 18.9515 7.95161C18.9835 7.86811 19 7.77862 19 7.68824C19 7.59786 18.9835 7.50836 18.9515 7.42486C18.9195 7.34136 18.8726 7.26549 18.8134 7.20158C18.7542 7.13767 18.684 7.08698 18.6067 7.05239C18.5294 7.0178 18.4466 7 18.3629 7C18.2792 7 18.1964 7.0178 18.1191 7.05239C18.0418 7.08698 17.9716 7.13767 17.9124 7.20158L9.45484 16.3395L6.08759 12.7005C6.02843 12.6366 5.9582 12.5859 5.8809 12.5513C5.8036 12.5168 5.72076 12.499 5.63709 12.499C5.55343 12.499 5.47058 12.5168 5.39329 12.5513C5.31599 12.5859 5.24576 12.6366 5.1866 12.7005C5.12744 12.7644 5.08051 12.8403 5.0485 12.9238C5.01648 13.0073 5 13.0968 5 13.1872C5 13.2776 5.01648 13.3671 5.0485 13.4506C5.08051 13.5341 5.12744 13.6099 5.1866 13.6738L9.00434 17.7981C9.06345 17.8621 9.13367 17.9129 9.21097 17.9475C9.28827 17.9822 9.37114 18 9.45484 18C9.53853 18 9.6214 17.9822 9.69871 17.9475C9.77601 17.9129 9.84623 17.8621 9.90533 17.7981L18.8134 8.17489Z" fill="white"/>
                </svg>
                <img src="${
                  colorGroups[group].image ||
                  "https://example.com/images/default.jpg"
                }" alt="${group}" width="" height="" class="image">
                <span class="color-name">${group}</span>
              </button>`
            )
            .join("")}
        </div>
        <div class="question--text prose">${questionData.content || ""}</div>
      </div>
    `;
  }

  renderFooterButtons(selectors);

  const optionButtons = selectors.quizContainer.querySelectorAll(
    ".option--button, .color--button"
  );
  optionButtons.forEach((button) => {
    const index = parseInt(button.dataset.index);
    if (selectedAnswers[questionIndex] === index) {
      button.classList.add("active");
    }
    button.addEventListener("click", function () {
      if (this.classList.contains("active")) {
        return;
      }
      optionButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
      selectAnswer(index);
    });
  });
}

function selectAnswer(answerIndex) {
  const selectors = getSelectors();
  const questionIndex = visibleQuestions[currentQuestionIndex];
  const questionData = selectors.quizData[questionIndex];

  const previousAnswerIndex = selectedAnswers[questionIndex];
  if (previousAnswerIndex !== undefined && questionData.type === "question") {
    const previousAnswer = questionData.answers[previousAnswerIndex];
    if (
      questionIndex < selectors.quizData.length - 1 &&
      previousAnswer.products
    ) {
      previousAnswer.products.forEach((product) => {
        productScores[product.p_title] = Math.max(
          0,
          productScores[product.p_title] - 1
        );
      });
    }
  }

  selectedAnswers[questionIndex] = answerIndex;

  if (questionData.type === "question") {
    const selectedAnswer = questionData.answers[answerIndex];
    if (
      questionIndex < selectors.quizData.length - 1 &&
      selectedAnswer.products
    ) {
      selectedAnswer.products.forEach((product) => {
        productScores[product.p_title] += 1;
      });
    }
  } else if (questionData.type === "color-option") {
    // const validGroups = Object.keys(colorGroups).filter(
    //    (group) => Object.keys(colorGroups[group].variants).length > 0
    // );
    const validGroups = Object.keys(colorGroups).filter(
          (group) => colorGroups[group].variants.length > 0
    );
    selectedColor = colorGroups[validGroups[answerIndex]].url;
  }

  for (let i = questionIndex + 1; i < selectors.quizData.length; i++) {
    if (selectedAnswers[i] !== undefined) {
      const prevAnswerIndex = selectedAnswers[i];
      const prevQuestion = selectors.quizData[i];
      if (
        i < selectors.quizData.length - 1 &&
        prevQuestion.type === "question" &&
        prevQuestion.answers[prevAnswerIndex].products
      ) {
        prevQuestion.answers[prevAnswerIndex].products.forEach((product) => {
          productScores[product.p_title] = Math.max(
            0,
            productScores[product.p_title] - 1
          );
        });
      }
      selectedAnswers[i] = undefined;
    }
  }

  if (questionIndex < selectors.quizData.length - 1) {
    selectedColor = "";
  }

  selectors.nextBtn.removeAttribute("disabled");
  updateVisibleQuestions();
  winningProduct(selectors);

  // console.log("Product Scores:", productScores);
  // console.log("Selected Color:", selectedColor);
}

function getWinningProductTitle() {
  const maxScore = Math.max(...Object.values(productScores));
  const maxScoreCount = Object.values(productScores).filter(
    (score) => score === maxScore
  ).length;

  if (maxScoreCount === 1) {
    // Clear winner
    return Object.keys(productScores).reduce((a, b) =>
      productScores[a] > productScores[b] ? a : b
    );
  } else {
    // Tie case
    for (const title of Object.keys(productScores)) {
      if (productScores[title] === maxScore) {
        return title;
      }
    }
  }
  return null;
}

function showResult(selectors) {
  const recommendedProductTitle = getWinningProductTitle();
  const resultData = selectors.resultJSON;

  let recommendedProduct = null;
  if (recommendedProductTitle) {
    selectors.quizData.forEach((question) => {
      if (question.type === "question") {
        question.answers.forEach((answer) => {
          answer.products?.forEach((product) => {
            if (product.p_title === recommendedProductTitle) {
              recommendedProduct = product;
            }
          });
        });
      }
    });
  }

  const images = recommendedProduct?.p_image || [];

  const usps_content = recommendedProduct.usps_icon
  ? `
    <div class="product--subtitle">
      <img src="${recommendedProduct.usps_icon}" alt="${recommendedProduct.usps_text}" class="svg">
      ${recommendedProduct.usps_text}
    </div>
  `
  : "";

  selectors.resultContainer.innerHTML = `
    <div class="result--title">${resultData.title}</div>
    <div class="result-page_wrapper">
      <div class="result--media">
        <div class="product--gallery swiper">
          <ul class="swiper-wrapper">
           ${
             images && images.length > 0
               ? images
                   .map(
                     (image) => `
                      <li class="swiper-slide">
                        <img src="${image.src}" alt="${recommendedProductTitle}" class="image">
                      </li>`
                   )
                   .join("")
               : '<li class="swiper-slide"><p>No images available</p></li>'
           }
          </ul>
          <button class="swiper-button swiper-button-prev">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
              <rect y="0.899902" width="40" height="40" rx="20" fill="white"/>
              <path d="M23.4922 26.7289L16.508 20.9005L23.4922 15.0708" stroke="black" stroke-width="1.366" stroke-miterlimit="20" stroke-linecap="round"/>
            </svg>
          </button>
          <button class="swiper-button swiper-button-next">
            <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
              <rect x="0.660156" y="0.899902" width="40" height="40" rx="20" fill="white"/>
              <path d="M17.168 26.7289L24.1522 20.9005L17.168 15.0708" stroke="black" stroke-width="1.366" stroke-miterlimit="20" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="result--content">
        ${usps_content}
        <h2 class="product--title">${recommendedProductTitle}</h2>
        <div class="product--des"><p>${recommendedProductTitle} ${resultData.description}</p></div>
        <div class="product--button">
          <a href="${recommendedProduct.p_handle}?color=${selectedColor
    .toLowerCase()
    .replace(/\s+/g, "-")}" class="button">${resultData.button}</a>
        </div>
      </div>
    </div>
  `;

  if (images && images.length > 0) {
    new Swiper(".product--gallery", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: ".swiper-button.swiper-button-next",
        prevEl: ".swiper-button.swiper-button-prev",
      },
    });
  }

  renderFooterButtons(selectors);
  const prevBtn = selectors.quizButtons.querySelector(".quiz-prev_button");
  const nextBtn = selectors.quizButtons.querySelector(".quiz-next_button");
  nextBtn.setAttribute("disabled", "true");
  prevBtn.setAttribute("disabled", "true");

  selectors.resultContainer.classList.remove("hidden");
  selectors.quizButtons.classList.add("hidden");

  selectors.quizContainer.innerHTML = "";
  selectors.quizContainer.classList.add("hidden");
  updateProgress(selectors, visibleQuestions.length);
}

function winningProduct(selectors) {
  const recommendedProductTitle = getWinningProductTitle();

  let recommendedProduct = null;
  if (recommendedProductTitle) {
    selectors.quizData.forEach((question, qIndex) => {
      if (question.type === "question") {
        question.answers.forEach((answer) => {
          answer.products?.forEach((product) => {
            if (product.p_title === recommendedProductTitle) {
              recommendedProduct = product;
            }
          });
        });
      }
    });
  }

  for (const groupName in colorGroups) {
    colorGroups[groupName].variants = [];
  }

  if (recommendedProduct && recommendedProduct.p_variants) {
    recommendedProduct.p_variants.forEach((variant) => {
      const title = variant.title?.toUpperCase() || "";
      // for (const groupName in colorGroups) {
      //   const preferredKeywords = colorGroups[groupName].preferred;
      //   for (const preferred of preferredKeywords) {
      //     if (title.includes(preferred)) {
      //       colorGroups[groupName].variants.push(variant);
      //       break;
      //     }
      //   }
      // }
      for (const groupName in colorGroups) {
        const preferredKeywords = colorGroups[groupName].preferred;

        const matched = preferredKeywords.some(keyword => 
          title.includes(keyword)
        );

        if (matched) {
          colorGroups[groupName].variants.push(variant);
          break;
        }
      }
    });
  }

  const validGroups = Object.keys(colorGroups).filter(
    (group) =>
      Array.isArray(colorGroups[group].variants) &&
      colorGroups[group].variants.length > 0
  );

   //console.log("Winning Product:", recommendedProduct);
   //console.log("Valid Groups after winningProduct:", validGroups);
   //console.log(colorGroups);
}

runAt(".ge-quiz_section", globalFunction);
